import { useEffect } from "react";
import "@/App.css";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import StudioStatement from "@/components/site/StudioStatement";
import FeaturedProjects from "@/components/site/FeaturedProjects";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import About from "@/components/site/About";
import Team from "@/components/site/Team";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyCTA from "@/components/site/StickyCTA";
import { useReveal } from "@/hooks/useReveal";

function App() {
  useReveal();

  useEffect(() => {
    document.title = "studio Brehaut architecture — Prince Edward Island";
  }, []);

  return (
    <div className="App bg-background text-foreground" data-testid="site-root">
      <Nav />
      <main>
        <Hero />
        <StudioStatement />
        <FeaturedProjects />
        <Services />
        <Process />
        <About />
        <Team />
        <Contact />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}

export default App;
